var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[ 'node-footer', _vm.item.classes ]},[_c('p',[_c('span',{domProps:{"innerHTML":_vm._s(_vm.$getLocaleString(_vm.item['job-code']))}}),_vm._v("  |  "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.$getLocaleString(_vm.item['date-of-prep']))}})]),_c('p',{domProps:{"innerHTML":_vm._s(_vm.$getLocaleString(_vm.item['copyright']))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }